import React, { Component } from 'react'

class Error extends Component {
  render() {
    return (
      <div>
          <h1>Error 404 Not Found</h1>
      </div>
    )
  }
}

export default Error